var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMarker',{attrs:{"position":_vm.position,"icon":_vm.companniaMarkerIcon,"label":{
    text: _vm.compannia.numero.toString(),
    color: 'white',
    fontSize: '11px'
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }